import { stegaClean } from 'next-sanity';

interface AnchorProps {
  block: {
    id?: string;
  };
}

export function Anchor({ block }: AnchorProps) {
  return <div id={stegaClean(block.id) || undefined} className="scroll-mt-22" />;
}
